// @flow weak
import useEventCallback from "use-event-callback"
import { getEnclosingBox } from "./region-tools.js"

export default ({ layoutParams, mat }) => {
  return useEventCallback((r) => {
    const { iw, ih } = layoutParams.current
    const bbox = getEnclosingBox(r)
    const margin = r.type === "point" ? 15 : 2
    // Calculate box in image coordinates (no margin yet)
    const cbox = {
      x: bbox.x * iw,
      y: bbox.y * ih,
      w: bbox.w * iw,
      h: bbox.h * ih,
    }
    // Transform to screen coordinates
    const transformed = mat.clone().inverse().applyToPoint(cbox.x, cbox.y)
    // Apply margin in screen space (so it doesn't scale with zoom)
    const pbox = {
      x: transformed.x - margin,
      y: transformed.y - margin,
      w: cbox.w / mat.a + margin * 2,
      h: cbox.h / mat.d + margin * 2,
    }
    return pbox
  })
}
